import ContactUs from '@/features/v2/hh/components/thankYou/ContactUs';
import FinishedAll from '@/features/v2/hh/components/thankYou/FinishedAll';
import NotQualify from '@/features/v2/hh/components/thankYou/NotQualify';
import OfferPage from '@/features/v2/summaryForms/components/offer/OfferPage';

export const stages = {
  stage_III_finished: {
    component: <FinishedAll />,
    progress: 'finished',
  },
  finished: {
    component: <FinishedAll />,
    progress: 'finished',
  },
  not_qualified: {
    component: <NotQualify />,
    progress: 'not_qualified',
  },
  contact_us: {
    component: <ContactUs />,
    progress: 'finished',
  },
  stage_I: {
    component: null,
    progress: 'default',
  },
  stage_II: {
    component: null,
    progress: 'default',
  },
  stage_III: {
    component: null,
    progress: 'default',
  },
  offer: {
    component: <OfferPage />,
    progress: null,
  },
  offer_finished: {
    component: <OfferPage />,
    progress: null,
  },
} as const;
